export default "__VITE_ASSET__CsozR24i__"